import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { PilotPayAccessToken, PilotPayAuthResponseOptions } from '../types/auth.type';
import { IdentityService } from '../identity/services/identity.service';
import { PilotPayHttpClient, SessionService } from '../core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
/**
 * RoleGuard
 */
@Injectable()
export class UserGuard implements CanActivate {
	constructor(
		private identityService: IdentityService,
		private sessionService: SessionService,
		private router: Router,
		private http: PilotPayHttpClient
	) {}

	// tslint:disable-next-line:variable-name
	public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
		const accessToken: PilotPayAccessToken = this.identityService.accessToken.getValue();

		if (!accessToken.payload.userData) {
			return false;
		}

		try {
			if (this.sessionService.getUser()) {
				return true;
			}
		} catch {}

		return this.http
			.getRequest<PilotPayAuthResponseOptions>(`/api/identity/user?email=${accessToken.payload.email}`)
			.pipe(
				map((response: PilotPayAuthResponseOptions): boolean => {
					this.sessionService.setUser(response);
					const url: string = state.url.replace(/\/+$/, '');
					if (url === '' || url === '/pilotpay') {
						if (response.isAdmin) {
							this.router.navigateByUrl('/pilotpay/admin').then();
						} else {
							this.router.navigateByUrl('/pilotpay/dashboard').then();
						}
						return false;
					}
					return true;
				})
			);
	}
}
